import AjaxUtils from './ajaxUtils';

export const getCreditsBalance = async () => AjaxUtils.get('/api/v1/account-assets/balances/display');
